import { INotificationBar, NotificationBar } from '@sanlam-glacier/app-common/components';

interface NotificationBarProps extends INotificationBar {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  variant?: INotificationBar['variant'] | undefined;
  status?: INotificationBar['status'] | undefined;
  className?: string;
  roundedTop?: boolean;
  roundedBottom?: boolean;
}

export const MultiLineNotificationBar = ({
  title,
  subtitle,
  variant,
  status,
  className
}: NotificationBarProps) => {
  return (
    <NotificationBar
      title={title}
      subtitle={subtitle}
      status={status}
      variant={variant ?? NotificationBar.VARIANT.SECONDARY}
      spacing={NotificationBar.SPACING.NORMAL}
      className={className}
      roundedTop
      roundedBottom
      highlight={false}
    />
  );
};
